<mat-icon
  [style.color]="company().companyColor"
  [matTooltip]="tooltip() !== undefined ? tooltip() : company().name"
  >image</mat-icon
>
